export default "__VITE_ASSET__Cd9j31kw__"